import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css, token, prefixCls }) => ({
  notice: css`
    &&.${prefixCls}-notification-notice {
      position: relative;
      width: 405px !important;
      max-width: calc(100vw - 48px);
      padding: 20px !important;
      background: ${token.colorBgElevated};
      border-radius: ${token.borderRadiusLG}px;
      box-shadow: 0 4px 2px rgba(0, 0, 0, 0.04);
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-message,
      &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-description {
      margin-bottom: 0 !important;
      margin-inline-start: 0 !important;
      padding-inline-end: 0 !important;
      color: ${token.colorText};
      font-weight: 400;
      word-break: break-word;
      hyphens: none;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-message {
      margin-bottom: 4px !important;
      padding-inline-end: 20px !important;
      font-size: ${token.fontSizeLG}px;
      line-height: 24px;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-description {
      font-size: ${token.fontSize}px;
      line-height: 18px;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-description:empty {
      display: none;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-description:not(:empty)
      + .${prefixCls}-notification-notice-btn {
      margin-top: 4px !important;
    }

    &&.${prefixCls}-notification-notice.${prefixCls}-notification-notice-closable
      .${prefixCls}-notification-notice-message {
      padding-inline-end: 20px !important;
    }

    &&.${prefixCls}-notification-notice-with-icon,
      &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-with-icon {
      display: block;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-with-icon
      .${prefixCls}-notification-notice-message,
      &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-with-icon
      .${prefixCls}-notification-notice-description,
      &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-with-icon
      .${prefixCls}-notification-notice-btn {
      margin-inline-start: 40px !important;
    }

    &&.${prefixCls}-notification-notice .${prefixCls}-notification-notice-icon {
      position: absolute;
      top: 20px;
      inset-inline-start: 20px;
      margin: 0;
      font-size: 24px;
      line-height: 1;
    }

    &&.${prefixCls}-notification-notice .${prefixCls}-notification-notice-btn {
      float: none;
      margin-top: 0;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-close {
      top: 20px;
      inset-inline-end: 20px;
      width: 16px;
      height: 16px;
      color: ${token.colorIcon};
      background: transparent;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-close:hover {
      color: ${token.colorText};
      background: transparent;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-close
      svg {
      font-size: 16px;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-progress {
      right: 6px;
      left: 6px;
      block-size: 2px;
      inline-size: auto;
      border-radius: 0;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-progress,
      &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-progress::-webkit-progress-bar {
      background: ${token.stepperWaitIconBg};
      border-radius: 0;
    }

    &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-progress::-webkit-progress-value,
      &&.${prefixCls}-notification-notice
      .${prefixCls}-notification-notice-progress::-moz-progress-bar {
      background: ${token.colorPrimary};
      border-radius: 0;
    }
  `,
  iconInfo: css`
    color: ${token.colorInfo};
  `,
  iconSuccess: css`
    color: ${token.colorSuccess};
  `,
  iconError: css`
    color: ${token.colorError};
  `,
  iconWarning: css`
    color: ${token.colorWarning};
  `,
  actions: css`
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: flex-end;
  `
}))
